module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-my"
  }, [_c('navbar', {
    attrs: {
      "title": _vm.navbarTitle
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "common-scroll",
    staticStyle: {
      "bottom": "0"
    },
    attrs: {
      "id": "common-scroll"
    }
  }, [_c('ul', {
    staticClass: "ui-listview paper-listview"
  }, [_c('li', [_c('label', {
    staticClass: "paper-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("证件类型：")]), _vm._v(" "), _c('div', {
    staticClass: "paper-shell"
  }, [_c('div', {
    staticClass: "paper-type",
    on: {
      "click": function($event) {
        return _vm.selectPaper(_vm.paperFont)
      }
    }
  }, [_vm._v(_vm._s(_vm.paperFont))])])]), _vm._v(" "), _c('li', [_c('label', {
    staticClass: "paper-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("证件名称：")]), _vm._v(" "), _c('div', {
    staticClass: "paper-shell"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paperName),
      expression: "paperName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入证件名称"
    },
    domProps: {
      "value": (_vm.paperName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paperName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('label', {
    staticClass: "paper-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("发证机关：")]), _vm._v(" "), _c('div', {
    staticClass: "paper-shell"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paperOrgan),
      expression: "paperOrgan"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入发证机关"
    },
    domProps: {
      "value": (_vm.paperOrgan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paperOrgan = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('label', {
    staticClass: "paper-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("生效日期：")]), _vm._v(" "), _c('div', {
    staticClass: "paper-shell"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.startDate),
      expression: "startDate"
    }],
    attrs: {
      "type": "date",
      "placeholder": "请选择生效日期"
    },
    domProps: {
      "value": (_vm.startDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.startDate = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('label', {
    staticClass: "paper-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("失效日期：")]), _vm._v(" "), _c('div', {
    staticClass: "paper-shell"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endDate),
      expression: "endDate"
    }],
    attrs: {
      "type": "date",
      "placeholder": "请选择失效日期"
    },
    domProps: {
      "value": (_vm.endDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endDate = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "paper-p"
  }, [_vm._v("附件：")]), _vm._v(" "), _c('div', {
    staticClass: "paper-image-shell",
    on: {
      "click": _vm.showAttachView
    }
  }, [(_vm.imgsrc === '') ? _c('img', {
    attrs: {
      "src": require("../../assets/back-img.svg")
    }
  }) : _c('w-img', {
    staticClass: "paper-image-item",
    attrs: {
      "src": _vm.imgsrc,
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    ref: "attachFile",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.preview($event)
      }
    }
  })], 1)]), _vm._v(" "), _c('a', {
    staticClass: "paper-new-add1",
    on: {
      "click": _vm.saveJudge
    }
  }, [_vm._v(_vm._s(_vm.btnFont))]), _vm._v(" "), _c('refresh', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show),
      expression: "!show"
    }],
    attrs: {
      "cls": _vm.cls,
      "font": _vm.font
    }
  }), _vm._v(" "), _c('mid-ware', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.midware),
      expression: "midware"
    }],
    attrs: {
      "icon": _vm.icon,
      "midFont": _vm.midFont
    }
  })], 1), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._v(" "), _c('select-paper', {
    ref: "typeShow",
    on: {
      "selectPaper": _vm.getSearchCondition
    }
  }), _vm._v(" "), _c('tips-auto', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsauto),
      expression: "tipsauto"
    }],
    attrs: {
      "tipsFont": _vm.tipsFont
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsTwoShow),
      expression: "tipsTwoShow"
    }],
    staticClass: "tips-mask-t",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.hideRuturnConfirm.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "tips-wrapper",
    class: {
      'tips-start': _vm.tipsTwoShow, 'tips-end': !_vm.tipsTwoShow
    }
  }, [_c('div', {
    staticClass: "tips-font"
  }, [_c('p', [_vm._v(_vm._s(_vm.elseTipsFont))])]), _vm._v(" "), _c('div', {
    staticClass: "tips-btns"
  }, [_c('a', {
    staticClass: "tips-two-btn tips-marbot red-font",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.saveReturn.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.elseBtnFont[0]))]), _vm._v(" "), _c('a', {
    staticClass: "tips-two-btn tips-marbot",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.quitRuturn.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.elseBtnFont[1]))]), _vm._v(" "), _c('a', {
    staticClass: "tips-two-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.hideRuturnConfirm.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.elseBtnFont[2]))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-94d431b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/paper-detail/PaperDetail.vue
// module id = 605
// module chunks = 1